module.exports = __webpack_public_path__ + "static/img/advertising.2d15787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo/advertising.png
// module id = eLRj
// module chunks = 1